module.exports = __webpack_public_path__ + "img/noise.5058f6b5.png";